import { render, staticRenderFns } from "./linkPriceListTemplate.vue?vue&type=template&id=19a08773&"
import script from "./linkPriceListTemplate.vue?vue&type=script&lang=js&"
export * from "./linkPriceListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports